import React from "react";

const InputGuide = ({ message }) => {
  return <p className="enrollment-form-input-guide capitalize">{message}</p>;
};
export default InputGuide;
